(function webpackUniversalModuleDefinition(e, r) {
  if (typeof exports === "object" && typeof module === "object") module.exports = r(require("lodash-es/endsWith"), require("lodash-es/fromPairs"));else if (typeof define === "function" && define.amd) define(["lodash-es/endsWith", "lodash-es/fromPairs"], r);else if (typeof exports === "object") exports["@mq/aurora-login"] = r(require("lodash-es/endsWith"), require("lodash-es/fromPairs"));else e["@mq/aurora-login"] = r(e["lodash-es/endsWith"], e["lodash-es/fromPairs"]);
})(typeof self !== "undefined" ? self : this, function (e, r) {
  return function () {
    "use strict";

    var n = {
      445: function (r) {
        r.exports = e;
      },
      652: function (e) {
        e.exports = r;
      }
    };
    var a = {};
    function __webpack_require__(e) {
      var r = a[e];
      if (r !== undefined) {
        return r.exports;
      }
      var t = a[e] = {
        exports: {}
      };
      n[e](t, t.exports, __webpack_require__);
      return t.exports;
    }
    !function () {
      __webpack_require__.n = function (e) {
        var r = e && e.__esModule ? function () {
          return e["default"];
        } : function () {
          return e;
        };
        __webpack_require__.d(r, {
          a: r
        });
        return r;
      };
    }();
    !function () {
      __webpack_require__.d = function (e, r) {
        for (var n in r) {
          if (__webpack_require__.o(r, n) && !__webpack_require__.o(e, n)) {
            Object.defineProperty(e, n, {
              enumerable: true,
              get: r[n]
            });
          }
        }
      };
    }();
    !function () {
      __webpack_require__.o = function (e, r) {
        return Object.prototype.hasOwnProperty.call(e, r);
      };
    }();
    !function () {
      __webpack_require__.r = function (e) {
        if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
          Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          });
        }
        Object.defineProperty(e, "__esModule", {
          value: true
        });
      };
    }();
    var t = {};
    !function () {
      __webpack_require__.r(t);
      __webpack_require__.d(t, {
        getDecodedFromUrl: function () {
          return getDecodedFromUrl;
        },
        getEncodedUrl: function () {
          return getEncodedUrl;
        },
        getHostname: function () {
          return getHostname;
        },
        getQueryParams: function () {
          return getQueryParams;
        },
        prependUrl: function () {
          return prependUrl;
        }
      });
      var e = __webpack_require__(445);
      var r = __webpack_require__.n(e);
      function validateUserNameLength(e) {
        var r = {
          isValid: true,
          message: ""
        };
        if (e.length === 0) {
          r.isValid = false;
          r.message = "";
        } else if (e.search(/\s/) >= 0) {
          r.isValid = false;
          r.message = "Username cannot contain spaces";
        }
        return r;
      }
      function validatePassword(e) {
        return e.length >= 6;
      }
      var defaultPassowrdPolicyState = function () {
        return {
          hasSevenCharacters: true,
          containMixCharacters: true,
          hasConsecutiveCharacters: false,
          hasSequenceCharacters: false,
          endsWithOverSixDigits: false
        };
      };
      function validateNewPassword(e, r) {
        var n = {
          isValid: true,
          message: "",
          passwordPolicy: defaultPassowrdPolicyState()
        };
        var a = e.search(/\d/) > -1;
        var t = e.search(/[a-z]/) > -1;
        var i = e.search(/[A-Z]/) > -1;
        var s = e.search(/[^a-zA-Z0-9]/) > -1;
        var o = e.split("");
        var u = 0;
        var c = 0;
        if (e.length < 7) {
          n.message = "Requires at least 7 characters";
          n.isValid = false;
          n.passwordPolicy.hasSevenCharacters = false;
        }
        var f = 0;
        if (t) {
          f++;
        }
        if (i) {
          f++;
        }
        if (a) {
          f++;
        }
        if (s) {
          f++;
        }
        if (f <= 1) {
          n.message = "Must contain a mix of letters, numbers, and/or special characters";
          n.isValid = false;
          n.passwordPolicy.containMixCharacters = false;
        }
        if (o.some(function (e, r, n) {
          if (e === n[r + 1]) {
            u++;
            return u >= 3;
          } else {
            u = 0;
            return false;
          }
        })) {
          n.message = "Cannot contain a sequence of characters (i.e “1111” or “aaaa”)";
          n.isValid = false;
          n.passwordPolicy.hasSequenceCharacters = true;
        }
        if (o.some(function (r, n, a) {
          if (e.charCodeAt(n) + 1 === e.charCodeAt(n + 1)) {
            c++;
            return c >= 3;
          } else {
            c = 0;
            return false;
          }
        })) {
          n.message = "Cannot contain consecutive characters (ie. “123455” or “abcdef”)";
          n.isValid = false;
          n.passwordPolicy.hasConsecutiveCharacters = true;
        }
        if (r && e.includes(r)) {
          n.message = "Cannot contain your username";
          n.isValid = false;
        }
        if (a && e.length >= 6) {
          var l = e.slice(e.length - 6 - 1);
          if (l.search(/\d{6,}/) > -1) {
            n.message = 'Cannot end with 6 or more numbers (ie. "abc120790”)';
            n.isValid = false;
            n.passwordPolicy.endsWithOverSixDigits = true;
          }
        }
        return n;
      }
      function validatePin(e) {
        var r = {
          isValid: true,
          pinPolicy: {
            hasRequiredCharacters: true,
            hasSpecialCharacters: false
          }
        };
        var n = e.search(/[^a-zA-Z0-9]/) > -1;
        if (e.length < 4 || e.length > 8) {
          r.isValid = false;
          r.pinPolicy.hasRequiredCharacters = false;
        }
        if (n) {
          r.isValid = false;
          r.pinPolicy.hasSpecialCharacters = true;
        }
        return r;
      }
      function getLocation(e) {
        var r = document.createElement("a");
        r.href = e;
        return r;
      }
      function validateFromUrlDomain(e) {
        var n = getLocation(e);
        var a = n.hostname;
        return (r()(a, ".gs.com") || a === "simonmarkets.com" || r()(a, ".simonmarkets.com")) && n.protocol === "https:";
      }
      function compareAuthLevels(e, r) {
        if (typeof e === "undefined" && typeof r !== "undefined") {
          return -1;
        }
        if (typeof r === "undefined" && typeof e !== "undefined") {
          return 1;
        } else if (e && r) {
          var n = parseInt(e, 10);
          var a = parseInt(r, 10);
          if (n === a) {
            return 0;
          } else if (n > a) {
            return 1;
          } else {
            return -1;
          }
        }
        return 0;
      }
      var n = __webpack_require__(652);
      var a = __webpack_require__.n(n);
      function getHostname() {
        if (window && window.location && window.location.hostname) {
          return window.location.hostname;
        }
        return undefined;
      }
      function getQueryParams(e) {
        return e ? a()(e.replace("?", "").split("&").map(function (e) {
          return e.split("=");
        })) : {};
      }
      function getDecodedFromUrl(e) {
        if (!e) {
          return undefined;
        }
        try {
          var r = atob(decodeURIComponent(e));
          return validateFromUrlDomain(r) ? r : undefined;
        } catch (e) {
          return undefined;
        }
      }
      function getEncodedUrl(e) {
        if (!e) {
          return undefined;
        }
        return encodeURIComponent(btoa(e));
      }
      function prependUrl(e, r) {
        return e ? "" + e + r : r;
      }
    }();
    return t;
  }();
});